export default {
  id: 'WebsiteEditPage',
  code: 'CN',
  text: {
    'Active Pages': '在线页面',
    'Inactive Pages': '下线页面',
    'Home Page': '主页',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Website/EditPageOnSideMenu/locale.js